<template>
  <div>
    <div v-for="(r, i) in row" :key="i">
      {{ r.rateData.rate.transit_time }}
    </div>
  </div>
</template>

<script>
import Bridge8Popover from './Bridge8Popover'
import { mdbIcon } from 'mdbvue'

export default {
  name: 'CalcRatesTableCellName',
  props: {
    row: {
      type: Array,
      required: true
    }
  },
  components: {
    Bridge8Popover,
    mdbIcon
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellTransitTime.vue